import { Outlet, useNavigate } from "react-router-dom";
import globalRouter from "../helper/global-router";

const MainLayout = () => {
  const navigate = useNavigate();
  globalRouter.navigate = navigate;

  return (
    <div className="max-w-2xl mx-auto w-full min-h-custom-screen justify-center bg-white min-[42rem]:border-x border-[#e2e2e2] text-base">
      <Outlet />
    </div>
  );
};

export default MainLayout;
